
import { useEffect } from 'react';
import RouteData from './admin/routes/routeData';
import './App.css';
import UserRouteData from './user/routes/userRouteData';

function App() {

  return (
    <div>
      <RouteData />
      <UserRouteData />
    </div>
  );
}
export default App;
